import React from 'react'

class UnpauseButton extends React.Component {

    render() {
        return <button onClick={() => this.props.unpauseGame() }>Start Auto</button>
    }
}

export default UnpauseButton